<template>
  <div style="margin-bottom: 100px">
    <div class="common">
      <h2>直销产品展示</h2>
    </div>
    <div class="productlist">
      <div @click="toDetail(item)" class="item" v-for="(item,index) in product" :key="index">
        <img v-show="item.volume" :src="item.volume" :alt="item.name">
        <img v-show="!item.volume" src="../lazyload.jpg" alt="">
        <div class="name">{{item.name}}</div>
        <div class="price">￥{{item.price}}</div>
      </div>
    </div>
    <el-pagination
      @current-change="currentChange"
      background
      layout="prev, pager, next"
      :page-size="8"
      :total="total">
    </el-pagination>
  </div>
</template>

<script type="text/ecmascript-6">
  import axios from 'axios'
  export default {
    name: "product",
    data() {
      return {
        product: '',
        total: 8
      }
    },
    mounted() {
      this.fetchData(1,8)
    },
    methods: {
      toDetail(item){
        this.$router.push({name: 'productDetail', params: {id : item.id}})
      },
      currentChange(aa){
        this.fetchData(aa,8)
      },
      fetchData(page,rows){
        let url = `/api/getSaProduct?page=${page}&rows=${rows}`
        axios.get(url).then(response => {
          this.product = response.data.rows
          this.total = response.data.total * 8
          console.log(response)
        })
      }
    },
    created(){

    }
  }
</script>

<style scoped>
  .common {
    width: 100%;
  }

  .common h2 {
    text-align: left;
    font-size: 22px;
    color: #666666;
    font-weight: 400;
    padding: 20px 20px;
    margin: 0;
  }

  .productlist {
    width: 100%;
    text-align: left;
    padding: 0 20px;
    margin-bottom: 40px;
  }

  .productlist .item {
    margin-right: 17px;
    margin-bottom: 20px;
    text-align: left;
    width: 210px;
    display: inline-block;
    vertical-align: top;
    cursor: pointer;
  }

  .productlist .item img {
    width: 210px;
    height: 210px;
    border: 1px solid #cccccc;
  }

  .productlist .item .name {
    font-size: 14px;
    color: #6e5251;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 1;
  }

  .productlist .item .name:hover {
    color: #000000;
  }

  .price {
    color: #f65751;
    font-size: 16px;
  }

  @media (max-width: 768px) {
    .productlist {
      padding: 0;
    }
    .productlist .item {
      margin: 2vw;
      text-align: left;
      width: 45%;
      display: inline-block;
      vertical-align: top;
      cursor: pointer;
    }
    .productlist .item img {
      width: 100%;
      height: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/list/product.vue